import React, { Component, Suspense } from "react";
import { Helmet } from "react-helmet";
import SecundaryNavbar from "../component/Navbar/SecundaryNavBar";
import { lazyWithRetry } from "../utils/lazyWithRetry";

const ServicesDetails = lazyWithRetry(() => import("../component/ServicesDetails"));
const Footer = lazyWithRetry(() => import("../component/Footer/Footer"));

const LoadingSpinner = () => (
  <div className="loading-fallback">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Cargando...</span>
    </div>
  </div>
);

class ServicesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: [
        { id: 1, to: "/", navheading: "Inicio" },
        { id: 2, to: "/#courses", navheading: "Cursos" },
        { id: 3, to: "/#contact", navheading: "Contacto" },
      ],
      navClass: "nav-sticky",
      fixTop: true
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Servicios de seguridad industrial | Seguridad al Límite</title>
          <meta
            name="description"
            content="Asesoría en SG-SST, planes de emergencia, brigadas, señalización, tareas de alto riesgo y planes de seguridad vial en Armenia, Quindío."
          />
          <link rel="canonical" href="https://seguridadallimite.com/servicios-seguridad-industrial" />
        </Helmet>
        <a href="#services" className="skip-link">Saltar al contenido</a>
        <SecundaryNavbar
          navItems={this.state.navItems}
          navClass={this.state.navClass}
          top={this.state.fixTop}
          breadcrumbs={[
            { label: "Inicio", href: "/" },
            { label: "Seguridad industrial" }
          ]}
        />

        <div className="page-main">
          <Suspense fallback={<LoadingSpinner />}>
            <ServicesDetails />
            <Footer />
          </Suspense>
        </div>
      </>
    );
  }
}

export default ServicesPage; 